import React from 'react';
import { Remote } from '@okapi/remote';

export type ProductCarouselProps = {
  products: string[];
  title?: string;
  carouselId?: string;
  className?: string;
  portalRootId?: string;
};

export const ProductCarousel: React.FC<ProductCarouselProps> = ({
  products,
  title = '',
  carouselId = '',
  className,
  portalRootId = '',
}) => {
  return (
    <Remote
      widget="product-carousel/root"
      id={'pdp-' + carouselId}
      data={{
        title: title,
        productsIds: products,
        showSeeMore: false,
        isFromPdp: true,
        elementBlock: carouselId,
        portalRootId,
      }}
      className={className}
    />
  );
};
